import { Domain, Member as BackendMember } from '@vivport/backend/types';

export interface Account {
  id: string;
  accountId: string;
  accountName: string;
  email: string;
  firstName: string;
  surname: string;
  isAccessible: boolean;
  isMfaEnabled: boolean;
  isEmailMfaEnabled?: boolean;
  currentMfaMethod?: 'EMAIL' | 'FIDO2' | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface Hub {
  id: number;
  name: string;
  isPersonal: boolean;
}

// Frontend Member type (deprecated - use BackendMember from @vivport/backend/types instead)
export interface Member {
  id: number;
  memberId: string;
  accountId: number;
  hubId: number;
  email: string;
  firstName: string;
  surname: string;
  domain: Domain;
  isActive: boolean;
  isAdmin: boolean;
  isPersonal: boolean;
  hub?: Hub; // Hub may be undefined if member data is incomplete
  createdAt: Date;
  updatedAt: Date;
}

// Helper function to get display name for a member
// Note: This works with the backend Member type which doesn't include firstName/surname or hub
// For display purposes, we use email and isPersonal since that's what's available
export function getMemberDisplayName(
  member: BackendMember | Member | null | undefined, 
  account?: { firstName?: string; surname?: string }
): string {
  if (!member) {
    return 'Unknown';
  }
  
  // Try to use account name if available, otherwise fall back to email
  // Backend Member has email, frontend Member might also have email
  const memberEmail = 'email' in member ? member.email : undefined;
  const fullName = account?.firstName && account?.surname 
    ? `${account.firstName} ${account.surname}`
    : memberEmail?.split('@')[0] || 'Member';
    
  if (member.isPersonal) {
    return fullName;
  } else {
    // For non-personal members, we don't have hub name in the member object
    // So we just show the name (hub info would need to be fetched separately if needed)
    return fullName;
  }
}
